"use client";

import React, { createRef } from "react";
import { INSBoxBaseComboProps, NSBoxBaseCombo } from "../components/NSBoxBaseCombo";
import { INSBox } from "./INSBox";
import { IBaseComponentProps, IValidationProps } from "../main";
import { NSBaseMetaTable } from "namirasoft-site";
import { BaseMetaColumn, BaseMetaTable, FilterItem, FilterItemOperator, SortItem } from "namirasoft-core";

export type NSBoxEntityProps<Data> =
	NSBoxEntityPropsOption<Data> & NSBoxEntityPropsInner<Data> & IBaseComponentProps & IValidationProps & INSBoxBaseComboProps<NSBoxEntity<Data>>

export interface NSBoxEntityPropsInner<Data> 
{
	input?: IBaseComponentProps;
	getValue: (item: Data) => string;
	getTitle: (item: Data) => string;
	getSort: () => SortItem | null;
}

export type NSBoxEntityPropsOption<Data> = NSBoxEntityPropsOption1<Data> | NSBoxEntityPropsOption2<Data>;

export interface NSBoxEntityPropsOption1<Data> 
{
	table: NSBaseMetaTable<any, any>;
	list?: (filters: FilterItem[] | null, page: number | null, size: number | null, sorts: SortItem[]) => Promise<{ count: number, rows: Data[] }>;
	table_name?: string;
	column_id_name?: string;
}

export interface NSBoxEntityPropsOption2<Data> 
{
	table?: NSBaseMetaTable<any, any>;
	list: (filters: FilterItem[] | null, page: number | null, size: number | null, sorts: SortItem[]) => Promise<{ count: number, rows: Data[] }>;
	table_name: string;
	column_id_name?: string;
}

export class NSBoxEntity<Data> extends React.Component<NSBoxEntityProps<Data>> implements INSBox
{
	public NSBoxBaseCombo = createRef<NSBoxBaseCombo<Data>>();
	constructor(props: NSBoxEntityProps<Data>)
	{
		super(props);
		this.isEmpty = this.isEmpty.bind(this);
		this.getError = this.getError.bind(this);
		this.getValue = this.getValue.bind(this);
		this.setValue = this.setValue.bind(this);
		this.getValueOne = this.getValueOne.bind(this);
		this.setValueOne = this.setValueOne.bind(this);
		this.getValueAll = this.getValueAll.bind(this);
		this.setValueAll = this.setValueAll.bind(this);
		this.getDataOne = this.getDataOne.bind(this);
		this.setDataOne = this.setDataOne.bind(this);
		this.getDataAll = this.getDataAll.bind(this);
		this.setDataAll = this.setDataAll.bind(this);
		this.reload = this.reload.bind(this);
	}
	isEmpty(value: string)
	{
		if ((value ?? "").trim())
			return false;
		return true;
	}
	getError(): string | null
	{
		return this.NSBoxBaseCombo.current?.getError() ?? null;
	}
	getValue(checkError: boolean = true): string[] | string | null
	{
		return this.NSBoxBaseCombo.current?.getValue(checkError) ?? null;
	}
	setValue(value: string[] | string | null, callback?: () => void): void
	{
		this.NSBoxBaseCombo.current?.setValue(value, callback);
	}
	getValueOne(checkError: boolean = true): string | null
	{
		return this.NSBoxBaseCombo.current?.getValueOne(checkError) ?? null;
	}
	setValueOne(value: string | null, callback?: () => void): void
	{
		this.NSBoxBaseCombo.current?.setValueOne(value, callback);
	}
	getValueAll(): string[]
	{
		return this.NSBoxBaseCombo.current?.getValueAll() ?? [];
	}
	setValueAll(values: string[], callback?: () => void): void
	{
		this.NSBoxBaseCombo.current?.setValueAll(values, callback);
	}
	getDataOne(checkError: boolean = true): Data | null
	{
		return this.NSBoxBaseCombo.current?.getDataOne(checkError) ?? null;
	}
	setDataOne(value: Data | null, callback?: () => void): void
	{
		this.NSBoxBaseCombo.current?.setDataOne(value, callback);
	}
	getDataAll(): Data[]
	{
		return this.NSBoxBaseCombo.current?.getDataAll() ?? [];
	}
	setDataAll(values: Data[], callback?: () => void): void
	{
		this.NSBoxBaseCombo.current?.setDataAll(values, callback);
	}
	reload()
	{
		this.NSBoxBaseCombo.current?.reload();
	}
	override render()
	{
		let onNew: (() => string | void) | undefined = this.props.onNew;
		let onList: (() => string | void) | undefined = this.props.onList;
		let onView: ((id: string) => string | void) | undefined = this.props.onList;
		if (this.props.table)
		{
			if (!onNew)
				onNew = () =>
				{
					return this.props.table?.front_end.getNewLink();
				};
			if (!onList)
				onList = () =>
				{
					return this.props.table?.front_end.getListLink();
				};
			if (!onView)
				onView = (id: string) =>
				{
					return this.props.table?.front_end.getViewLink(id);
				};
		}
		return <NSBoxBaseCombo<Data>
			ref={this.NSBoxBaseCombo}
			{...this.props}
			onNew={onNew}
			onList={onList}
			onView={onView}
			getItems={async (id: string | null, search: string | null, page: number | null, size: number | null, sorts: SortItem[]) =>
			{
				let filters = [];
				let table_name = this.props.table_name ?? this.props.table?.name ?? "";
				let column_id_name = this.props.column_id_name ?? "id";
				let table_text = this.props.table_name ?? this.props.table?.text ?? "";
				let table = new BaseMetaTable(null, table_name, table_text);
				if (id)
				{
					let column = new BaseMetaColumn(table, column_id_name, "", "", false);
					filters.push(new FilterItem(table, column, false, FilterItemOperator.all.equals, id));
				}
				else if (search)
				{
					let column = new BaseMetaColumn(table, "*", "", "", false);
					filters.push(new FilterItem(table, column, false, FilterItemOperator.all.equals, search));
				}
				if (this.props.list)
					return this.props.list?.(filters, page, size, sorts);
				if (this.props.table?.back_end.list)
					return this.props.table?.back_end.list(filters, page, size, sorts);
				return { count: 0, rows: [] };
			}}
			onChanged={(_) =>
			{
				this.props.onChanged?.(this);
			}}
			onClicked={(_) =>
			{
				this.props.onClicked?.(this);
			}}
		/>
	}
}